/**
 * Errors muted before they reach Elasticsearch.
 *
 * Anything listed here is invisible to monitoring, so the bar is high: no user-visible effect,
 * and frequent enough to bury real faults. Every entry states its cause and when to remove it —
 * a mute is temporary, not a verdict that the error is acceptable.
 */

const MUTED_ERROR_PATTERNS = [
    /**
     * CKEditor teardown: "Unhandled promise rejection: ... (reading 'destroy')".
     *
     * Caused by a version mismatch we own — `@ckeditor/ckeditor5-react` 3.0.3 drives
     * `ckeditor5` 41.4.2 and bundles its own older watchdog, so two generations ship together
     * and only the old one guards its destructor (`t => t && t.destroy()` vs
     * `context => context.destroy()`). `ContextWatchdog._destroy` nulls its context before the
     * async chain finishes, so a concurrent destroy hits the unguarded one. Fires while an
     * editor unmounts, after teardown effectively happened.
     *
     * Remove once the wrapper is aligned with CKEditor 41 — not a version bump: the matching
     * releases need newer React than this app's 16.13, and every CKEditor call site is affected.
     * Matching only the rejection wording is deliberate; thrown synchronously it is a different
     * problem and must stay visible.
     */
    /Unhandled promise rejection:.*(?:Cannot read propert(?:y|ies) of null \(reading 'destroy'\)|null is not an object.*destroy)/i
];

export const isMutedError = message =>
    typeof message === "string" && MUTED_ERROR_PATTERNS.some(pattern => pattern.test(message));
